import HeroSection from "./sections/HeroSection";
import TechMarqueeSection from "./sections/TechMarqueeSection";
import ServicesSection from "./sections/ServicesSection";
import ProcessSection from "./sections/ProcessSection";
import PricingSection from "./sections/PricingSection";
import ContactSection from "./sections/ContactSection";
import ContactModalSection from "./sections/ContactModalSection";
import ImageBannerSection from "./sections/ImageBannerSection";
import ImageWithTextSection from "./sections/ImageWithTextSection";
import RichTextSection from "./sections/RichTextSection";
import LegalContentSection from "./sections/LegalContentSection";
import PrivacyContentSection from "./sections/PrivacyContentSection";
import CollageSection from "./sections/CollageSection";
import VideoBannerSection from "./sections/VideoBannerSection";
import SlideshowSection from "./sections/SlideshowSection";
import VideoSection from "./sections/VideoSection";
import FeaturedProductSection from "./sections/FeaturedProductSection";
import FeaturedCollectionSection from "./sections/FeaturedCollectionSection";
import CollectionListSection from "./sections/CollectionListSection";
import RecommendedProductsSection from "./sections/RecommendedProductsSection";
import MulticolumnSection from "./sections/MulticolumnSection";
import PromoBannerSection from "./sections/PromoBannerSection";
import BlogSection from "./sections/BlogSection";
import NewsletterSection from "./sections/NewsletterSection";
import LogoListSection from "./sections/LogoListSection";
import StatsBarSection from "./sections/StatsBarSection";
import FeatureGridSection from "./sections/FeatureGridSection";
import FaqSection from "./sections/FaqSection";
import HeroSplitSection from "./sections/HeroSplitSection";
import HeroCenteredSection from "./sections/HeroCenteredSection";
import HeroImageSection from "./sections/HeroImageSection";
import TestimonialsSection from "./sections/TestimonialsSection";
import TeamSection from "./sections/TeamSection";
import TimelineSection from "./sections/TimelineSection";
import OpeningHoursSection from "./sections/OpeningHoursSection";
import ComparisonTableSection from "./sections/ComparisonTableSection";
import CtaBannerSection from "./sections/CtaBannerSection";
import ProductGridSection from "./sections/ProductGridSection";
import CheckoutFormSection from "./sections/CheckoutFormSection";
import PriceListSection from "./sections/PriceListSection";
import GallerySection from "./sections/GallerySection";
import BeforeAfterSection from "./sections/BeforeAfterSection";
import BookingSection from "./sections/BookingSection";
import MapLocationSection from "./sections/MapLocationSection";
import ContactConfirmationPage from "./pages/ContactConfirmationPage";

// Registre du moteur de thème "default" — déplacé tel quel depuis
// frontend/src/lib/sectionRegistry.js lors de l'introduction de
// l'isolation par moteur de thème (voir
// /home/codespace/.claude/plans/curried-wondering-pumpkin.md et
// frontend/src/themes/registry.js pour le dispatch). Doit rester en phase
// avec le catalogue backend du même moteur
// (backend/services/theme_engines/default/sections.py) : le backend ne
// connaît que le TYPE de chaque section (jamais le composant) — c'est ici,
// et seulement ici, que ce type se résout en contenu visuel pour CE
// moteur. Un autre moteur aurait son propre registre, dans son propre
// dossier frontend/src/themes/<moteur>/registry.js — jamais un import
// depuis ce fichier.
export const SECTION_REGISTRY = {
  hero: { label: "Bandeau principal", Component: HeroSection },
  tech_marquee: { label: "Bandeau technologies", Component: TechMarqueeSection },
  services: { label: "Nos expertises", Component: ServicesSection },
  process: { label: "Notre méthode", Component: ProcessSection },
  pricing: { label: "Tarifs", Component: PricingSection },
  contact: { label: "Contact", Component: ContactSection },
  contact_modal: { label: "Contact (fenêtre)", Component: ContactModalSection },
  image_banner: { label: "Bannière image", Component: ImageBannerSection },
  image_with_text: { label: "Image et texte", Component: ImageWithTextSection },
  rich_text: { label: "Texte enrichi", Component: RichTextSection },
  collage: { label: "Collage", Component: CollageSection },
  video_banner: { label: "Bannière vidéo", Component: VideoBannerSection },
  slideshow: { label: "Diaporama", Component: SlideshowSection },
  video: { label: "Vidéo", Component: VideoSection },
  featured_product: { label: "Produit en vedette", Component: FeaturedProductSection },
  featured_collection: { label: "Collection en vedette", Component: FeaturedCollectionSection },
  collection_list: { label: "Liste de collections", Component: CollectionListSection },
  recommended_products: { label: "Produits recommandés", Component: RecommendedProductsSection },
  multicolumn: { label: "Multi-colonnes", Component: MulticolumnSection },
  promo_banner: { label: "Bannière promo", Component: PromoBannerSection },
  blog_section: { label: "Articles", Component: BlogSection },
  newsletter: { label: "Newsletter", Component: NewsletterSection },
  logo_list: { label: "Logos partenaires", Component: LogoListSection },
  stats_bar: { label: "Bandeau de chiffres clés", Component: StatsBarSection },
  feature_grid: { label: "Grille de fonctionnalités", Component: FeatureGridSection },
  faq_section: { label: "Questions fréquentes", Component: FaqSection },
  // Modèles ALTERNATIFS d'ouverture de page. L'assistant ne compose qu'en
  // choisissant des types de section : lui en proposer plusieurs est la
  // seule façon de lui laisser le choix du style d'ouverture.
  hero_split: { label: "Bandeau principal — image à côté", Component: HeroSplitSection },
  hero_centered: { label: "Bandeau principal — centré", Component: HeroCenteredSection },
  hero_image: { label: "Bandeau principal — image plein écran", Component: HeroImageSection },
  // Sections « récit et preuve » — entièrement textuelles, donc ce que
  // l'assistant sait réellement composer d'un métier à l'autre.
  testimonials: { label: "Avis clients", Component: TestimonialsSection },
  team: { label: "Équipe", Component: TeamSection },
  timeline: { label: "Parcours", Component: TimelineSection },
  opening_hours: { label: "Horaires et accès", Component: OpeningHoursSection },
  comparison_table: { label: "Tableau comparatif", Component: ComparisonTableSection },
  cta_banner: { label: "Bandeau d'appel à l'action", Component: CtaBannerSection },
  product_grid: { label: "Grille de produits", Component: ProductGridSection },
  checkout_form: { label: "Formulaire de commande", Component: CheckoutFormSection },
  // Nouvelles sections « métier » (juin 2026) — génériques, réutilisables
  // par tous les thèmes ; doivent rester en phase avec le catalogue backend
  // du même moteur (theme_engines/default/sections.py).
  price_list: { label: "Carte & tarifs", Component: PriceListSection },
  gallery: { label: "Galerie d'images", Component: GallerySection },
  before_after: { label: "Avant / Après", Component: BeforeAfterSection },
  booking: { label: "Prise de rendez-vous", Component: BookingSection },
  map_location: { label: "Carte & localisation", Component: MapLocationSection },
  // Page partagée par tous les moteurs (backend theme_engines/shared_pages.py).
  legal_content: { label: "Mentions légales", Component: LegalContentSection },
  privacy_content: { label: "Politique de confidentialité", Component: PrivacyContentSection },
};

// Couche d'EXTENSION des sections PARTAGÉES (importées des autres moteurs
// sous leur type préfixé — voir themes/shared.js) : pour adapter une section
// importée à la particularité de CE moteur, y déclarer un composant qui
// remplace ou enveloppe celui d'origine, ex. :
//
//   import AgenceHero from "../agence_v1/sections/HeroSection";
//   const HeroPourIci = (p) => <div className="…"><AgenceHero {...p} /></div>;
//   export const SHARED_EXTENSIONS = { agence_hero: { Component: HeroPourIci, label: "…" } };
//
// Le pendant serveur (textes par défaut, champs, pages, libellé) est
// `shared_overrides` du CATALOG du moteur (backend theme_engines/<moteur>/).
export const SHARED_EXTENSIONS = {};

export const DEFAULT_SECTION_ORDER = ["hero", "tech_marquee", "services", "process", "pricing", "contact"];

// Pages hors sections rendues par le moteur (voir themes/registry.js,
// champ PAGES). Ce moteur sert aussi de REPLI pour tout moteur qui n'en
// déclare pas : sa page de confirmation ne dépend que des jetons de palette.
export const PAGES = {
  contact_confirmation: ContactConfirmationPage,
};

// Pages de SECTIONS du moteur : chemin public → template (voir
// pages/EnginePage.jsx). Ce moteur n'a que la page PARTAGÉE par tous les
// moteurs — la politique de confidentialité, miroir de PAGES dans
// backend/services/theme_engines/default/sections.py (shared_pages.py).
// `seoKey` est la clé de Gestion SEO, `title`/`description` le repli tant
// que l'admin n'y a rien saisi.
export const ROUTES = {
  // Pages PARTAGÉES par tous les moteurs (backend theme_engines/shared_pages.py) :
  // mentions légales et politique de confidentialité, gérées par thème.
  "/mentions-legales": {
    template: "legal",
    seoKey: "mentions-legales",
    title: "Mentions légales",
    description: "Informations légales, données personnelles et cookies.",
  },
  "/confidentialite": {
    template: "privacy",
    seoKey: "confidentialite",
    title: "Politique de confidentialité",
    description: "Comment nous utilisons vos données de navigation pour améliorer le site.",
  },
};
